import { render } from "./VideosSlick.vue?vue&type=template&id=e9da0eee"
import script from "./VideosSlick.vue?vue&type=script&lang=js"
export * from "./VideosSlick.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/VideosSlick.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e9da0eee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e9da0eee', __exports__)) {
    api.reload('e9da0eee', __exports__)
  }
  
  module.hot.accept("./VideosSlick.vue?vue&type=template&id=e9da0eee", () => {
    api.rerender('e9da0eee', render)
  })

}


export default __exports__